import { Checkbox, Empty, Form, Modal, Progress, Spin, Upload } from 'antd'
import Button from 'components/Button'
import Control from 'components/Control/Control'
import Date from 'components/Date/Date'
import AntdInput from 'components/Form/Input'
import AntdSelect from 'components/Form/Select'
import AddIcon from 'components/icons/AddIcon'
import CrossIconSkill from 'components/icons/CrossIconSkill'
import Label from 'components/Label/Label'
import FileReader from 'components/Uploader/FileReader'
import Uploadloader from 'components/Uploader/Uploader'
import { updateCurrentState } from 'modules/Onboarding/actions'
import {
  boardList,
  educationDetails,
} from 'modules/Onboarding/Register/Education/constant'
import {
  educationDetailsBefore,
} from 'modules/Onboarding/Register/EducationNew/constant'
import {
  AdjustIcon,
  FormItem,
  Heading,
  LocalDiv,
  OptionWrapper,
  SelectLocalWrapper,
  SpinWrapper,
  Text,
} from 'modules/Onboarding/Register/Education/style'
import EducationForm from 'modules/Onboarding/Register/EducationNew/EducationFormPartial'
import {
  CountryCode,
  genderOptions,
} from 'modules/Onboarding/Register/PersonalInfo/Constant'
import {
  // Heading,
  // FormItem,
  // SpinWrapper,
  RedNote,
  StyledInput,
  StyledInputDiv,
  StyledSelectDiv,
} from 'modules/Onboarding/Register/PersonalInfo/style'
import moment from 'moment'
import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { searchConfig } from 'utils/config'
import { getEducationLevelLabel } from 'utils/const'
import ErrorMessage from 'utils/ErrorMessage'
import { debounce, getBoardbyName, normalizeString } from 'utils/helpers'
import SuccessMessage from 'utils/SuccessMessage'
import { StyledDiv } from '../../Dashboard/Style/style'
import CheckboxData from 'components/Checkbox/Checkbox'
import { FlexWrapRole, TitleTextPopup } from './style'
import { getValuebyName } from 'utils/helpers'
const { Dragger } = Upload
const { Option } = SelectLocalWrapper
import { upsertStudentResume, getStudentResumeData } from "modules/Resume/actions"

const initialErrorState = {
  permCountry: '',
  permState: '',
  permCity: '',
  corrCountry: '',
  corrState: '',
  corrCity: '',
};


const ProfileFormModal = ({
  visible,
  onClose,
  onSubmit,
  studentData,
  countryList,
  getListOfCountries,
  getListOfState,
  getListOfCity,
  loading: initialLoading = false,
  getListOfSkills,
  searchAPI,
  stateList,
  studentFormData,
  updateStudentData,
  updateCvDetails,
  getStudentData,
  showDrawer,
  viewRoleDetails,
  getSingleRoleDetails,
  fetchEligleDetails,
  fetchStudentData,
  pendingData,
  onStartCvUpload = () => {},
  onCvProgress = () => {},
  onFinishCvUpload = () => {},
  getCities,
  setApplyBeforeConfirm,
  deleteEducation,
  setExternalConfirm,
}) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const formRef = useRef();
  const params = useParams()
  // Form state
  const [loading, setLoading] = useState(initialLoading)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [file, setFile] = useState(null)
  const [gender, setGender] = useState('')
  const [dob, setDob] = useState(null)
  const [countryCode, setCountryCode] = useState('+91')

  const hasRejectedMandatoryEducation = () => {
    if (!pendingData || !pendingData.requests) return false
    
    const rejectedEducation = pendingData.requests.filter(request => {
      if (request.status === 'REJECTED' && request.fieldName === 'educationProfile') {
        const educationData = request.requestedData
        const educationLevel = educationData?.educationLevel?.toLowerCase()
        return educationLevel === 'tenth' || educationLevel === 'twelfth' || educationLevel === 'sslc'
      }
      return false
    })
    
    return rejectedEducation.length > 0
  }

  const mergePendingWithApproved = (approvedList, pendingList) => {
    if (!pendingList || pendingList.length === 0) return approvedList
    
    const pendingMap = new Map()
    pendingList.forEach(pending => {
      if (pending.id && !pending.id.startsWith('temp-')) {
        pendingMap.set(pending.id, pending)
      }
    })
    
    const mergedList = approvedList.map(approved => {
      const pending = pendingMap.get(approved.id)
      
      if (pending && pending._pendingFields) {
        const merged = { ...approved }
        
        Object.keys(pending._pendingFields).forEach(fieldName => {
          merged[fieldName] = pending._pendingFields[fieldName].value
        })
        
        merged._hasPendingChanges = true
        merged._pendingFields = pending._pendingFields
        merged._requestId = Object.values(pending._pendingFields)[0]?._requestId
        
        return merged
      }
      
      return approved
    })
    
    const newPendingItems = pendingList.filter(p => 
      p._isNew || (p.id && p.id.startsWith('temp-'))
    )
    
    return [...mergedList, ...newPendingItems]
  }

  // Address state
  const [permCountryList, setPermCountryList] = useState([])
  const [permStateList, setPermStateList] = useState([])
  const [permCityList, setPermCityList] = useState([])
  const [permCountryName, setPermCountryName] = useState('')
  const [permStateName, setPermStateName] = useState('')
  const [permCityName, setPermCityName] = useState('')
  const [permCountryId, setPermCountryId] = useState('')
  const [permStateId, setPermStateId] = useState('')
  const [permCityId, setPermCityId] = useState('')

  // Current Address state
  const [corrCountryList, setCorrCountryList] = useState([]);
  const [corrStateList, setCorrStateList] = useState([]);
  const [corrCityList, setCorrCityList] = useState([]);
  const [corrCountryName, setCorrCountryName] = useState('');
  const [corrStateName, setCorrStateName] = useState('');
  const [corrCityName, setCorrCityName] = useState('');
  const [corrCountryId, setCorrCountryId] = useState('');
  const [corrStateId, setCorrStateId] = useState('');
  const [corrCityId, setCorrCityId] = useState('');
  const [isSameAddress, setIsSameAddress] = useState(studentFormData?.studentPersonalProfile?.isSameCorresponding);

  // Loading states
  const [loadingCountry, setLoadingCountry] = useState(false)
  const [loadingState, setLoadingState] = useState(false)
  const [loadingCity, setLoadingCity] = useState(false)

  // Error state
  const [errorNote, setErrorNote] = useState(initialErrorState)

  // Preferred job location variables
  const [isAnyWhere, setIsAnyWhere] = useState(studentFormData?.studentPersonalProfile?.isAnywhere || false)
  const [locations, setLocations] = useState([])
  const [perfCityList, setPerfCityList] = useState([])

  // Education-related state variables
  const [education, setEducation] = useState([])
  const [educationList, setEducationList] = useState([])
  const [updatedList, setUpdatedList] = useState([])
  const [universityName, setUniversityName] = useState('')
  const [universitySearchList, setUniversitySearchList] = useState([])
  const [searchState, setSearchState] = useState('')
  const [refreshKey, setRefreshKey] = useState(1)
  const [skillLoading, setSkillLoading] = useState(true)
  const [stateId, setStateId] = useState('')
  const [locationData, setLocationData] = useState({
    stateId: '',
    state: '',
    cityId: '',
    city: '',
  })
  const [cityId, setCityId] = useState('')
  const [examType, setExamType] = useState('')
  const [duration, setDuration] = useState('')
  const [instituteCampusName, setInstituteCampusName] = useState('')
  const [universityId, setUniversityId] = useState('')
  const [instituteId, setInstituteId] = useState('')
  const [shown, setShown] = useState([])
  const [currentInstituteId, setCurrentInstituteId] = useState(
    studentData?.student?.instituteCampusId || null
  )
  const [currentInstituteName, setCurrentInstituteName] = useState(
    studentData?.student?.instituteCampusName || null
  )
  const [searchCollege, setSearchCollege] = useState('')
  const [listOfAddedSkills, setListOfAddedSkills] = useState([])
  const [allSkills, setAllSkills] = useState([])

  // Redux selectors
  const universityList = useSelector(
    state => state?.studentData?.universityList
  )
  const AllCollegeList = useSelector(state => state?.resumeData?.AllCollegeList)
  const CollegeList = useSelector(state => state?.resumeData?.CollegeList)
  const [cvDetails, setCvDetails] = useState(studentData?.cvDetails || {})
  const [loadingCV, setLoadingCV] = useState(initialLoading)
  const [prevCvUrl, setPrevCvUrl] = useState(studentData?.cvUrl || '') // Use the usePrevious hook
  const [progress, setProgress] = useState(0)
  const { COUNTRY_ID } = process.env
  useEffect(() => {
    // Check if cvUrl is an empty object, missing required properties, or has valid value
    if (studentData?.cvUrl) {
      // Check for empty object or missing required properties (url, name, size)
      if (Object.keys(studentData?.cvUrl).length === 0 || (!studentData?.cvUrl?.url && !studentData?.cvUrl?.name && !studentData?.cvUrl?.size)) {
        setPrevCvUrl('')
      } else {
        setPrevCvUrl(studentData?.cvUrl)
      }
    } else {
      setPrevCvUrl('')
    }
    //  setCvDetails(studentData?.cvDetails)
  }, [studentData?.cvUrl])
  const removeCv = () => {
    setCvDetails({})
    setPrevCvUrl('')
    setLoadingCV(false)
  }
  const uploadCV = async (file, submit = true) => {
    // START
    onStartCvUpload() // inform parent to switch modals
    let isUpdated = false
    setLoadingCV(true)
     try {
          const resumeResponse = await dispatch(getStudentResumeData())
          const existingResumes = resumeResponse?.resumes || []
          if (existingResumes.length >= 5) {
            allowResumeSave=false;
          }
          const updatedResumes = [
            ...existingResumes,
            {
              id: null,
              resumeName: file.name,
              resumeType: "UPLOADED",
              fileFormat: "pdf",
              fileUrl: { url: file.url },
              isDefault: false,
              fileSize: file.size
            }
          ]
          await dispatch(
            upsertStudentResume({
              resumes: updatedResumes
            })
          )
        } catch (err) {
          console.error("Resume save failed", err)
        }
    if (!submit) {
      setCvDetails(file)
    }
    let cvData = studentData?.cvDetails
    // for service
    if (
      file &&
      submit &&
      (cvDetails?.url !== prevCvUrl ||
        (cvDetails?.url == prevCvUrl && cvData && !Object.keys(cvData)?.length))
    ) {
      const interval = setInterval(() => {
        onCvProgress(prevProgress => {
          const nextProgress = prevProgress + 10
          if (nextProgress >= 100) {
            clearInterval(interval)
            return 100
          }
          return nextProgress
        })
      }, 2000)
      isUpdated = await updateCvDetails(studentData?.id, {
        url: file?.url,
      })
      if (isUpdated) {
        getStudentData()
        onCvProgress(90)
        //   setLoadingCV(false)
        setPrevCvUrl(file)
        setTimeout(() => {
          //  setCurrent(activeKey + 1)
        }, 2000)
      } else {
        setLoadingCV(false)
        onCvProgress(0)
        ErrorMessage('Failed to parse this CV !')
      }
    } else if (submit) {
      setLoadingCV(false)
      setTimeout(() => {
        // setCurrent(activeKey + 1)
      }, 1000)
    }

    if (submit) {
      if (!studentFormData?.admin?.dob) delete studentFormData?.admin?.dob
      if (!studentFormData?.admin?.gender) delete studentFormData?.admin?.gender
      // Don't delete profileUrl - keep the uploaded profile picture
      // if (!studentFormData?.student?.profileUrl)
      //   delete studentFormData?.student?.profileUrl
      if (!studentFormData?.studentPersonalProfile?.permPostCode)
        delete studentFormData?.studentPersonalProfile?.permPostCode
      if (!studentFormData?.studentPersonalProfile?.corrPostCode)
        delete studentFormData?.studentPersonalProfile?.corrPostCode
      if (!studentFormData?.studentPersonalProfile?.secondaryEmail)
        delete studentFormData?.studentPersonalProfile?.secondaryEmail
      let payload = {
        admin: {
          ...studentFormData.admin,
        },
        student: {
          ...studentFormData.student,
          profileUrl: form.getFieldValue('profileUrl') || studentFormData?.student?.profileUrl || undefined, // Get profile picture from form (newly uploaded) or fallback to existing; `undefined` (not '') so a not-yet-loaded value never overwrites the saved photo
          cvUrl: file ?? {},
        },
        studentPersonalProfile: {
          ...studentFormData?.studentPersonalProfile,
        },
        currentCourse: !studentFormData?.student?.isExpCandidate
          ? {
              ...studentFormData?.currentCourse,
              skills:
                studentFormData?.currentCourse?.skills == null
                  ? []
                  : studentFormData?.currentCourse?.skills,
            }
          : {},
        degreeStreamMap: !studentFormData?.student?.isExpCandidate
          ? {
              degreeId: studentFormData?.currentCourse?.degreeId,
              streamId: studentFormData?.currentCourse?.streamId,
            }
          : {},

        education: studentFormData?.education,
        resume: studentFormData?.resume,
      }
      if (payload?.currentCourse?.degreeStreamMapId === null) {
        delete payload?.currentCourse?.degreeStreamMapId
      }
      studentFormData?.education?.map((item, index) => {
        if (item?.skills === null) delete payload?.education[index]?.skills
        if (item?.markSheetUrl === null)
          delete payload?.education[index]?.markSheetUrl
        if (item?.degreeStreamMapId === null)
          delete payload?.education[index]?.degreeStreamMapId
      })

      let response = await updateStudentData(payload)
      if (response?.success === true) {
        setLoading(false)
        getStudentData()
        onCvProgress(100)
        setLoadingCV(false)
        onFinishCvUpload() // inform parent to switch modals
      } else {
        setLoading(false)
        onCvProgress(100)
        setLoadingCV(false)
        onFinishCvUpload() // inform parent to switch modals
        ErrorMessage(
          response?.response?.data?.message ?? 'Something went wrong'
        )
      }
    }
  }

  useEffect(() => {
    getCountryData()
    getStateData()
    getCityData()
  }, [studentData])
  // Initialize form with student data if available
  // useLayoutEffect(() => {
  //   if (studentData) {

  //     const studentProfile = studentData?.studentPersonalProfile || {};

  //     // Set personal info
  //     setGender(studentProfile?.gender || '');
  //     setDob(studentData?.admin?.dob ? moment(studentData?.admin?.dob) : null);

  //     // Set address info
  //     setPermCountryName(studentProfile?.permCountry || '');
  //     setPermStateName(studentProfile?.permState || '');
  //     setPermCityName(studentProfile?.permCity || '');
  //     setPermCountryId(studentProfile?.permCountryId || '');
  //     setPermStateId(studentProfile?.permStateId || '');
  //     setPermCityId(studentProfile?.permCityId || '');
  //     setIsAnyWhere(studentProfile?.isAnywhere || false);
  //     form.setFieldsValue({
  //       isAnyWhere: studentProfile?.isAnyWhere || false,
  //     })

  //     // Initialize form values
  //     form.setFieldsValue({
  //       phoneNumber: studentData?.admin?.phone_number || '',
  //       gender: studentProfile?.gender || '',
  //       dob: studentData?.admin?.dob ? moment(studentData?.admin?.dob) : undefined,

  //       // Address
  //       permPostCode: studentProfile?.permPostCode || '',
  //       permCountry: studentProfile?.permCountry || '',
  //       permState: studentProfile?.permState || '',
  //       permCity: studentProfile?.permCity || '',
  //       permCountryId: studentProfile?.permCountryId || '',
  //       permStateId: studentProfile?.permStateId || '',
  //       permCityId: studentProfile?.permCityId || '',
  //     });
  //   }
  // }, [studentData]);

  useLayoutEffect(() => {
    const adminData = studentData?.admin || {}
    const personalData = studentData?.studentPersonalProfile || {}
    const personDetailsFromCV =
      studentData?.cvDetails?.studentPersonalProfile || {}

    const dob = personalData?.dob || studentData?.cvDetails?.admin?.dob || ''
    const formattedDOB =
      dob && moment(dob, moment.ISO_8601, true).isValid()
        ? moment(dob)
        : undefined

    const isAnyWhere = personalData?.isAnywhere || false

    const phoneNumber = adminData?.phone_number || ''
    const gender = personalData?.gender || personDetailsFromCV?.gender || ''

    let permPostCode =
      personalData?.permPostCode || personDetailsFromCV?.permPostCode || ''
    if (!/^\d{6}$/.test(permPostCode)) {
      permPostCode = ''
    }

    // Set India as default country if no country is selected
    const permCountry =
      personalData?.permCountry || personDetailsFromCV?.permCountry || 'India'
    const permState =
      personalData?.permState || personDetailsFromCV?.permState || ''
    const permCity =
      personalData?.permCity || personDetailsFromCV?.permCity || ''
    // Use environment variable COUNTRY_ID for the country ID
    const permCountryId = personalData?.permCountryId || COUNTRY_ID || '';
    const permStateId = personalData?.permStateId || '';
    const permCityId = personalData?.permCityId || '';
  
    // Get current address data
    let corrPostCode = personalData?.corrPostCode || personDetailsFromCV?.corrPostCode || '';
    if (!/^\d{6}$/.test(corrPostCode)) {
      corrPostCode = '';
    }

    const corrCountry = personalData?.corrCountry || personDetailsFromCV?.corrCountry || 'India';
    const corrState = personalData?.corrState || personDetailsFromCV?.corrState || '';
    const corrCity = personalData?.corrCity || personDetailsFromCV?.corrCity || '';
    const corrCountryId = personalData?.corrCountryId || COUNTRY_ID || '';
    const corrStateId = personalData?.corrStateId || '';
    const corrCityId = personalData?.corrCityId || '';
    
    // Check if current address is same as permanent
    const isSameAddr = personalData?.isSameCorresponding || false;

    // Set form values
    form.setFieldsValue({
      isAnyWhere,
      phoneNumber,
      gender,
      dob: formattedDOB,
      // Permanent address
      permPostCode,
      permCountry,
      permState,
      permCity,
      permCountryId,
      permStateId,
      permCityId,
      // Current address
      corrPostCode: isSameAddr ? permPostCode : corrPostCode,
      corrCountry: isSameAddr ? permCountry : corrCountry,
      corrState: isSameAddr ? permState : corrState,
      corrCity: isSameAddr ? permCity : corrCity,
      corrCountryId: isSameAddr ? permCountryId : corrCountryId,
      corrStateId: isSameAddr ? permStateId : corrStateId,
      corrCityId: isSameAddr ? permCityId : corrCityId,
    });
  
    // Optional: set local state if needed
    setIsAnyWhere(isAnyWhere);
    setPerfCityList();
    setDob(formattedDOB);
    setGender(gender);
    
    // Set permanent address state
    setPermCountryName(permCountry);
    setPermStateName(permState);
    setPermCityName(permCity);
    setPermCountryId(permCountryId);
    setPermStateId(permStateId);
    setPermCityId(permCityId);
    
    // Set current address state
    setIsSameAddress(isSameAddr);
    if (isSameAddr) {
      setCorrCountryName(permCountry);
      setCorrStateName(permState);
      setCorrCityName(permCity);
      setCorrCountryId(permCountryId);
      setCorrStateId(permStateId);
      setCorrCityId(permCityId);
    } else {
      setCorrCountryName(corrCountry);
      setCorrStateName(corrState);
      setCorrCityName(corrCity);
      setCorrCountryId(corrCountryId);
      setCorrStateId(corrStateId);
      setCorrCityId(corrCityId);
    }
  }, [studentData, studentFormData]);

  useEffect(() => {
    getStateData(permCountryId, '')
  }, [permCountryId])

  const isCorporateMasterExist = (value, name) => {
    return !form.getFieldValue(name + 'Id')
  }

   useLayoutEffect(() => {
      let values = form.getFieldValue([])
      console.log(values?.permCountry,'values?.permCountry')
      getCountryData(values?.permCountry, false, true)
    }, [])


    const updateCountryData = async countryList => {
      let personalData = form.getFieldValue([])
  
      let countryName = personalData.permCountry
      if (countryName && countryList) {
        let countryObj = getValuebyName(countryList, countryName)
        if (countryObj) {
          personalData.permCountryId = countryObj?._id
          personalData.permCountry = countryObj?.name
    
          await getStateData(countryObj?._id, personalData?.permState, false, true)
          setPermCountryId(countryObj?._id)
          setPermCountryName(countryObj?.name)
          form.setFieldsValue({ permCountry: personalData.permCountry })
          form.setFieldsValue({ permCountryId: personalData.permCountryId })
        } else {
          setPermCountryName('')
  
          form.setFieldsValue({ permCountry: '' })
          form.setFieldsValue({ permCountryId: '' })
          form.setFieldsValue({ permState: '' })
          form.setFieldsValue({ permStateId: '' })
          form.setFieldsValue({ permCity: '' })
          form.setFieldsValue({ permCityId: '' })
          setPermCityName('')
          setPermStateName('')
          setErrorNote(prevError => ({
            ...prevError,
            permCountry: `No data matched for : ${countryName}`,
          }))
          getCountryData('')
        }
      } else if (countryName) {
          setPermCountryName('')
  
          form.setFieldsValue({ permCountry: '' })
          form.setFieldsValue({ permCountryId: '' })
          form.setFieldsValue({ permState: '' })
          form.setFieldsValue({ permStateId: '' })
          form.setFieldsValue({ permCity: '' })
          form.setFieldsValue({ permCityId: '' })
          setPermCityName('')
          setPermStateName('')
          setErrorNote(prevError => ({
            ...prevError,
            permCountry: `No data matched for : ${countryName}`,
          }))
          getCountryData('')
        }
      
    }
    const updateStateData = async (countryId, stateList) => {
      let personalData = form.getFieldValue([])
      let stateName = personalData?.permState
      let stateId = personalData?.permStateId
      let cityName = personalData?.permCity || ''
      if (stateName && stateList) {
        if (!stateId) {
          let stateObj = getValuebyName(stateList, stateName)
          if (stateObj) {
            setPermStateId(stateObj?._id)
            personalData.permStateId = stateObj?._id
            personalData.permState = stateObj?.name
  
            form.setFieldsValue({ permState: personalData?.permState })
            form.setFieldsValue({ permStateId: personalData?.permStateId })
           
            await getCityData(countryId, stateObj?._id,  cityName,false, true)
          } else {
            form.setFieldsValue({ permState: '' })
            form.setFieldsValue({ permStateId: '' })
            form.setFieldsValue({ permCity: '' })
            form.setFieldsValue({ permCityId: '' })
            setPermCityName('')
            setPermStateName('')
            setErrorNote(prevError => ({
              ...prevError,
              permState: `No data matched for : ${stateName}`,
            }))
            await getStateData(countryId, true, '')
          }
        }
      } else if (stateName) {
          form.setFieldsValue({ permState: '' })
          form.setFieldsValue({ permStateId: '' })
          form.setFieldsValue({ permCity: '' })
          form.setFieldsValue({ permCityId: '' })
  
          setPermCityName('')
          setPermStateName('')
          setErrorNote(prevError => ({
            ...prevError,
            permState: `No data matched for : ${stateName}`,
          }))
          await getStateData(countryId,  '',false, true)
        }
      
    }
    const updateCityData = async cityList => {
      let personalData = form.getFieldValue([])
      let cityName = personalData.permCity
      let cityId = personalData.permCityId
      if (cityName && cityList) {
        if (!cityId) {
          let cityObj = getValuebyName(cityList, cityName)
          if (cityObj) {
            setPermCityId(cityObj?._id)
            personalData.permCityId = cityObj?._id
            personalData.permCity = cityObj?.name
            form.setFieldsValue({ permCity: personalData.permCity })
            form.setFieldsValue({ permCityId: personalData.permCityId })
          } else {
            form.setFieldsValue({ permCity: '' })
            form.setFieldsValue({ permCityId: '' })
            setPermCityName('')
            setErrorNote(prevError => ({
              ...prevError,
              permCity: `No data matched for : ${cityName}`,
            }))
            await getCityData(permCountryId, personalData?.permStateId, '',false, true)
          }
        }
      } else if (cityName) {
          form.setFieldsValue({ permCity: '' })
          form.setFieldsValue({ permCityId: '' })
          setPermCityName('')
          setErrorNote(prevError => ({
            ...prevError,
            permCity: `No data matched for : ${cityName}`,
          }))
          await getCityData(permCountryId, personalData?.permStateId, '',false, true)
        }
      
    }
  // Country, State, City APIs
  const getCountryData = async (search, isCorr = false, initial = false) => {
    setLoadingCountry(true);
    let list = await getListOfCountries(search, true, setLoadingCountry);
    if (initial && search) {
      await updateCountryData(list)
    }
    if (isCorr) {
      
      setCorrCountryList(list || []);
    } else {
      setPermCountryList(list || []);
      setCorrCountryList(list || []);
    }
 
    setLoadingCountry(false);
    return list || [];
  };

  const getStateData = async (countryId, search, isCorr = false,initial = false) => {
    if (countryId) {
      setLoadingState(true);
      let list = await getListOfState(countryId, search, true, setLoadingState);
      if (initial && search) {
        await updateStateData(countryId, list)
      }
      if (isCorr) {
        setCorrStateList(list || []);
      } else {
        setPermStateList(list || []);
        setCorrStateList(list || []);
      }
      setLoadingState(false);
      return list || [];
    }
  }

  const getCityData = async (countryId,stateId, search, isCorr = false,initial = false) => {
    if (stateId) {
      setLoadingCity(true);
      let list = await getListOfCity(countryId, stateId, search, true, setLoadingCity);
      if (initial && search) {
        await updateCityData(list)
      }
      if (isCorr) {
        setCorrCityList(list || []);
      } else {
        setPermCityList(list || []);
        setCorrCityList(list || []);
      }
      setLoadingCity(false);
      return list || [];
    }
  }

  const delayCountryToDb = useCallback(
    debounce(data => {
      form.setFieldsValue({
        permCountryName: '',
        permCountryNameId: '',
      })
      setPermCountryName('')
      setPermCountryId('')
      //  getListOfCountries(data, false)
      getCountryData(data)
      setErrorNote(prevError => ({
        ...prevError,
        permCountryName: '',
        permStateName: '',
        permCityName: '',
      }))
    }, 500),
    []
  )
  // Debounced search functions
  const delayStateToDb = useCallback(
    debounce((countryId, search) => {
      form.setFieldsValue({
        permState: '',
        permStateId: '',
      })
      setPermStateName('')
      setPermStateId('')
      getStateData(countryId, search)
      setErrorNote(prevError => ({
        ...prevError,
        permState: '',
        permCity: '',
      }))
    }, 500),
    []
  )

  const delayCitiesToDb = useCallback(
    debounce((countryId, stateId, search) => {
      form.setFieldsValue({
        permCity: '',
        permCityId: '',
      })
      setPermCityId('')
      setPermCityName('')
      getCityData(countryId, stateId, search)
      setErrorNote(prevError => ({
        ...prevError,
        permCity: '',
      }))
    }, 500),
    []
  )

  // Preferred job location handlers
  const isAnyWhereOnChange = data => {
    setIsAnyWhere(data?.target?.checked)
    form.setFieldsValue({
      isAnyWhere: data?.target?.checked,
    })
  }

  const locationHandler = (selectedValues, selectedOptions) => {
    const selectedPayloads = selectedOptions?.map(item => item.option)

    form.setFieldsValue({
      preferredJobLocation: selectedPayloads,
    })
    setLocations(selectedPayloads)
  }

  // const delayCitiesToDbForPreferredLocation = useCallback(
  //   debounce(async (search) => {
  //     try {
  //       // This would typically call an API to get city data
  //       // For now, we'll just add some placeholder cities
  //       const results = search
  //         ? [
  //           { id: 'city1', name: search + ' City' },
  //           { id: 'city2', name: 'New ' + search },
  //           { id: 'city3', name: search + ' Metropolitan' }
  //         ]
  //         : [
  //           { id: 'city1', name: 'Bangalore' },
  //           { id: 'city2', name: 'Mumbai' },
  //           { id: 'city3', name: 'Delhi' },
  //           { id: 'city4', name: 'Chennai' },
  //           { id: 'city5', name: 'Hyderabad' }
  //         ];

  //       setPerfCityList(results);
  //     } catch (error) {
  //       console.error('Error fetching cities:', error);
  //     }
  //   }, 500),
  //   []
  // );

  const delayCitiesToDbForPreferredLocationSearch = useCallback(
    debounce(async search => {
      try {
        let list = await getCities(search)

        const newOptions = [
          ...list.cities.map(city => ({
            value: city.city_id,
            label: city.city_name,
            type: 'city',
            payload: city,
          })),
          ...list.states.map(state => ({
            value: state.state_id,
            label: state.state_name,
            type: 'state',
            payload: state,
          })),
        ]
        setPerfCityList(newOptions)
      } catch (error) {
        console.error('Error fetching cities:', error)
      }
    }, 300),
    []
  )

  // Initialize cities list
  useEffect(() => {
    delayCitiesToDbForPreferredLocationSearch('')
  }, [])

  // Event handlers
  const onGenderChange = value => {
    setGender(value)
    form.setFieldsValue({ gender: value })
  }

  const validateDateOfBirth = dateString => {
    const date = moment(dateString, 'DD/MM/YYYY', true)
    return date.isValid()
  }
  const onDateChange = (date, dateString) => {
    const isValidDate = validateDateOfBirth(dateString)
    const modifiedDateFormat = date ? moment(date).format('YYYY-MM-DD') : null
    if (!isValidDate) {
      form.setFieldsValue({ dob: null })
      setDob(null)
      //  setError('Please enter a valid date of birth (DD/MM/YYYY)')
    }
    if (isValidDate) {
      form.setFieldsValue({ dob: modifiedDateFormat })
      setDob(modifiedDateFormat)
      //  setError('')
    }
  }

  const onCountryChange = (data, option) => {
    setPermCountryId(option?.option?._id)
    setPermCountryName(option?.option?.name)
    form.setFieldsValue({
      permCountryId: option?.option?._id,
      permCountry: option?.option?.name,
      permStateId: '',
      permState: '',
      permCityId: '',
      permCity: '',
    })
    setPermStateId('')
    setPermStateName('')
    setPermCityId('')
    setPermCityName('')
    delayStateToDb(option?.option?._id, '')
    // delayCountryToDb('')
  }

  const onStateChange = (data, option) => {
    setPermStateId(option?.option?._id)
    setPermStateName(option?.option?.name)
    setPermCityId('')
    setPermCityName('')
    form.setFieldsValue({
      permStateId: option?.option?._id,
      permState: option?.option?.name,
      permCityId: '',
      permCity: '',
    })
    delayCitiesToDb(permCountryId, option?.option?._id, '')
  }

  const onCityChange = (data, option) => {
    setPermCityId(option?.option?._id)
    setPermCityName(option?.option?.name)
    form.setFieldsValue({
      permCityId: option?.option?._id,
      permCity: option?.option?.name,
    })
  }

  const onCountryCodeChange = value => {
    setCountryCode(value)
  }

  const validatePhoneNumber = (_, value) => {
    if (!value) {
      return Promise.reject('Please enter phone number')
    }
    if (!/^[0-9]{10}$/.test(value)) {
      return Promise.reject('Please enter a valid 10-digit phone number')
    }
    return Promise.resolve()
  }

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields()
      setSubmitLoading(true)

      // Process education data
      let educationList = []
      let educationDeleteList = []
      let currentCourse = []
      let tenth = false
      let twelth = false
      let diploma = false
      let under = false

      const convertedData = Object.keys(values).reduce((acc, key) => {
        if (
          key.includes('ug_') ||
          key.includes('pg_') ||
          key.includes('diploma_') ||
          key.includes('phd_') ||
          key.includes('p_g_diploma')
        ) {
          const [name, award] = key.split('award+')
          const value = values[key]
          if (!acc[name]) {
            acc[name] = {
              ...value,
              awards: [],
            }
          }
          if (key.includes('award+')) acc[name].awards.push({ ...value })
        } else {
          acc[key] = values[key]
        }
        return acc
      }, {})
      // Process education data
    
      Object.values(convertedData)?.forEach(data => {
        if (data?.isDelete) {
          educationDeleteList.push(data?.id)
        } else if (data?.noOfArrears >= 0) {
          currentCourse.push({
            ...data,
            averageMarks: data?.marks ? data?.marks : 0,
        })
        } else if(data?.marks && !data?.noOfArrears){
          const educationItem = {
            ...data,
            state: data?.state || '',
            stateId: data?.stateId || '',
            city: data?.city || '',
            cityId: data?.cityId || '',
            educationLevel: getEducationLevel1(data?.educationLevel),
            //   startedOn: data?.startedOn ? moment(data?.startedOn, 'MM/YYYY').format('x') : null,
            endedOn: data?.endedYear
              ? moment(data?.endedYear, 'YYYY').format('x')
              : null,
            skills:
              data?.skills?.map(skill => ({
                id: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
                  skill.id
                )
                  ? skill.id
                  : '',
                name: skill.name,
              })) || [],
            tcUrl: data?.tcUrl || {},
            markSheetUrl: data?.markSheetUrl || {},
            university: data?.university || null,
            historyOfArrears: data?.historyOfArrears || 0,
          }

          educationList.push(educationItem)

          // Track education levels
          const level = data?.educationLevel?.toLowerCase()
          if (level === 'tenth') tenth = true
          if (level === 'twelfth' || level === 'sslc' || level === 'diploma') {
            if (level === 'diploma') diploma = true
            else twelth = true
          }
        }
      })

      // Validate mandatory education
      // if (!tenth) {
      //   ErrorMessage('10th is Mandatory');
      //   setSubmitLoading(false);
      //   return;
      // }
      // if (!twelth && !diploma) {
      //   ErrorMessage('12th or Diploma is Mandatory');
      //   setSubmitLoading(false);
      //   return;
      // }

      let payload = {
        admin: {
          ...studentFormData?.admin,
          dob: values?.dob
            ? moment(values?.dob).format('YYYY-MM-DD')
            : studentData?.studentPersonalProfile?.dob,
          gender: values?.gender
            ? values?.gender
            : studentData?.studentPersonalProfile?.gender,
          phoneNumber: values?.phoneNumber
            ? values?.phoneNumber
            : studentData?.admin?.phone_number,
        },
        studentPersonalProfile: {
          ...studentFormData?.studentPersonalProfile,

          permCity: values?.permCity,
          permState: values?.permState,
          permPostCode: values?.permPostCode,
          permCountry: values?.permCountry,
          permCityId: values?.permCityId,
          permStateId: values?.permStateId,
          permCountryId: values?.permCountryId,
          corrCityId: values?.corrCityId,
          corrStateId: values?.corrStateId,
          corrCountryId: values?.corrCountryId,
          corrCity: values?.corrCity,
          corrState: values?.corrState,
          corrPostCode: values?.corrPostCode,
          corrCountry: values?.corrCountry,
          isSameCorresponding: isSameAddress,
          preferredJobLocation:  values?.preferredJobLocation?.map(item => item.payload ?? item) || [],
          isAnywhere: isAnyWhere,
        },
        student: {
          ...studentFormData?.student,
        },
        currentCourse: !studentData?.isExpCandidate
          ? { ...studentFormData?.currentCourse, 
            noOfArrears: currentCourse[0]?.noOfArrears,
            specialisationId: currentCourse[0]?.specialisationId,
            specialisation: currentCourse[0]?.specialisation ?? null,
            averageMarks: currentCourse[0]?.averageMarks,
           }
          : {},
        education: educationList.map(educationItem => ({
          ...educationItem,
        })),
        resume: studentFormData?.resume,
        degreeStreamMap:
          !studentFormData?.student?.isExpCandidate &&
          studentFormData?.currentCourse?.degreeId &&
          studentFormData?.currentCourse?.streamId
            ? {
                degreeId: studentFormData?.currentCourse?.degreeId,
                streamId: studentFormData?.currentCourse?.streamId,
              }
            : {},
      }
      delete payload?.currentCourse?.startMonth
      delete payload?.currentCourse?.startYear
      delete payload?.currentCourse?.endMonth
      delete payload?.currentCourse?.endYear

      payload?.education.map((item, index) => {
        delete payload?.education[index]?.startMonth
        delete payload?.education[index]?.startYear
        delete payload?.education[index]?.endMonth
        delete payload?.education[index]?.endYear

        return null
      })

      if (payload?.currentCourse?.specialisationId === null) {
        delete payload?.currentCourse?.specialisationId
      }
      if (payload?.currentCourse?.skills === null) {
        delete payload?.currentCourse?.skills
      }
      if (
        payload?.studentPersonalProfile?.secondaryEmail === null ||
        payload?.studentPersonalProfile?.secondaryEmail === ''
      ) {
        delete payload?.studentPersonalProfile?.secondaryEmail
      }
      if (
        payload?.currentCourse?.degreeStreamMapId === null ||
        !payload?.currentCourse?.degreeStreamMapId
      ) {
        delete payload?.currentCourse?.degreeStreamMapId
      }
      //here
      if (payload?.studentPersonalProfile) {
        Object.keys(payload.studentPersonalProfile).forEach(key => {
          if (payload.studentPersonalProfile[key] === null) {
            delete payload.studentPersonalProfile[key]
          }
        })
      }
      payload?.education.map((item, index) => {
        if (item?.skills === null || item?.skills == '')
          delete payload?.education[index]?.skills
        if (!item?.degreeStreamMapId)
          delete payload?.education[index]?.degreeStreamMapId
        return null
      })
      educationList?.map((value, index) => {
        for (const [key, value1] of Object.entries(value)) {
          if (key === 'educationLevel' && value1 === 'tenth') {
            tenth = true
          }
          if (key === 'educationLevel' && value1 === 'twelfth') {
            twelth = true
          }
          if (key === 'educationLevel' && value1 === 'diploma') {
            diploma = true
          }
          if (key === 'educationLevel' && value1 === 'ug') {
            under = true
          }
        }
        return null
      })

      currentCourse?.map((value, index) => {
        for (const [key, value1] of Object.entries(value)) {
          if (
            (key === 'educationLevel' && value1 === 'ug') ||
            (key === 'educationLevel' && value1 === 'UG')
          ) {
            under = true
          }
          if (key === 'educationLevel' && value1 === 'diploma') {
            diploma = true
          }
        }
        return null
      })
      if (tenth && checkMandatory(twelth, diploma)) {
        // Check if 10th or 12th education has been rejected
        if (hasRejectedMandatoryEducation()) {
          setSubmitLoading(false)
          ErrorMessage('Your 10th or 12th education has been rejected by TPO. Please update and resubmit for approval before applying.')
          return
        }
        
        let response = await updateStudentData(payload)
        if (response?.success === true) {
        //  await dispatch(updateCurrentState(studentData?.id, 4))
          if (educationDeleteList?.length > 0) {
            educationDeleteList.map(async item => {
              await deleteEducation(item)
            })
          }

          SuccessMessage('Education details saved successfully!')
          //here
          await fetchStudentData()
        let roleDetails =  await getSingleRoleDetails(params.CorpID, params.JobID)
          let eligleDetails = await fetchEligleDetails()

          setSubmitLoading(false)
          if(eligleDetails?.isEligible && !roleDetails?.isRestricted && (roleDetails?.role?.externalLink === null || roleDetails?.role?.externalLink === "")){
            setApplyBeforeConfirm(true)
          }
          else if(eligleDetails?.isEligible && !roleDetails?.isRestricted && roleDetails?.role?.externalLink){
            setExternalConfirm(true)
          }
          else{
            showDrawer(viewRoleDetails)
          }
          onClose()
        } else {
          setSubmitLoading(false)

          ErrorMessage(response?.response?.data?.message)
        }
      } else if (!tenth && checkMandatory(twelth, diploma)) {
        setSubmitLoading(false)

        ErrorMessage('10th is Mandatory')
      } else if (tenth && !checkMandatory(twelth, diploma)) {
        setSubmitLoading(false)

        ErrorMessage('12th or Diploma is Mandatory')
      } else if (!tenth && !checkMandatory(twelth, diploma)) {
        setSubmitLoading(false)
        ErrorMessage('10th And 12th or Diploma is Mandatory')
      }
      //       // Prepare final form data
      //       const formData = {
      //         ...values,
      //         education: educationList,
      //         educationDeleteList,
      //         cvFile: file,
      //         isAnyWhere,
      //         preferredJobLocation: isAnyWhere ? [] : locations,
      //       };
      // await onSubmit(formData);
    } catch (error) {
      console.error('Validation failed:', error)

      // Handle validation errors
      // if (error.errorFields) {
      //   const errorForms = error.errorFields.map(item => item.name[0]);
      //   const updatedValues = {};
      //   Object.keys(form.getFieldsValue()).forEach(key => {
      //     updatedValues[key] = {
      //       ...form.getFieldValue(key),
      //       shown: errorForms.includes(key),
      //     };
      //   });
      //   form.setFieldsValue(updatedValues);
      //   setShown(errorForms);

      //   // Scroll to first error
      //   if (formRef.current && error.errorFields.length > 0) {
      //     const firstError = error.errorFields[0];
      //     formRef.current.scrollToField(firstError.name);
      //   }
      // }
    } finally {
      setSubmitLoading(false)
    }
  }
  const checkMandatory = (twelth, diploma) => {
    return twelth === true || diploma === true
  }
  const scrollToFirstError = async errors => {
    if (!errors?.length) return
    // AntD returns array sorted by field order; pick the FIRST field
    const firstErrorField = errors[0]
    let namePath = firstErrorField.name
    // When AntD wraps list fields the first element can itself be an array (e.g. [["twelfth"], "board"]) – flatten it
    if (Array.isArray(namePath[0])) {
      namePath = [...namePath[0], ...namePath.slice(1)]
    }
    // Use form instance (via ref) to scroll smoothly
    formRef.current?.scrollToField(namePath, {
      behavior: 'smooth',
      block: 'center',
    })
    let values =  await form.getFieldValue()
    
    // Handle errors with nested name arrays
    const errorForms = []
    const updatedValues = { ...values }
    
    errors.forEach(error => {
      if (Array.isArray(error.name) && Array.isArray(error.name[0])) {
        const level = error.name[0][0]
        updatedValues[level] = { 
          ...updatedValues[level], 
          shown: true 
        }
        errorForms.push(level)
      }
    })
    
    form.setFieldsValue(updatedValues)
    setShown(errorForms)
    
     
  }
  // Education utility functions
  const getEducationLevelValue = (value, isUpdate = false, educationsList) => {
    if (
      value === 'diploma' ||
      value === 'p_g_diploma' ||
      value === 'ug' ||
      value === 'pg' ||
      value === 'phd'
    ) {
      let list = (isUpdate ? educationsList : education)?.filter(data =>
        data?.level?.includes(value)
      )
      if (value === 'ug') {
        return 'ug' + '_' + list?.length
      } else if (value === 'diploma') {
        return 'diploma' + '_' + list?.length
      } else if (value === 'pg') {
        return 'pg' + '_' + list?.length
      } else if (value === 'phd') {
        return 'phd' + '_' + list?.length
      } else if (value === 'p_g_diploma') {
        return 'p_g_diploma' + '_' + list?.length
      }
    } else {
      return value
    }
  }

  const getEducationLevel = level => {
    let name = level?.replaceAll('_', '')
    return name?.replace(/\d/g, '')
  }

  const getEducationLevelSearch = level => {
    let name = level?.replaceAll('_', '')
    let result = name?.replace(/\d/g, '')
    return result === 'pgdiploma'
      ? 'P_G_DIPLOMA'
      : result === 'pd'
      ? 'PHD'
      : result?.toUpperCase()
  }

  const getEducationLevel1 = level => {
    let name = level?.replaceAll('_', '')
    return name === 'pgdiploma'
      ? 'p_g_diploma'
      : name?.replace(/\d/g, '')?.toLowerCase()
  }

  const getAddedLevel = value => {
    let levelsList = updatedList?.map(data => data?.level)

    if (
      value === 'diploma' ||
      value === 'p_g_diploma' ||
      value === 'ug' ||
      value === 'pg' ||
      value === 'phd'
    ) {
      return true
    } else {
      return levelsList.includes(value)
    }
  }

  useLayoutEffect(() => {
    let educationsList = []
    let tenth = false
    let twelfth = false
    educationList?.forEach(data => {
      let educationLevel = data.educationLevel?.toLowerCase()
      if (educationLevel == 'hsc') {
        data.educationLevel = 'tenth'
      }
      if (educationLevel === 'tenth' || educationLevel === 'hsc') {
        tenth = true
      }
      if (
        educationLevel === 'twelfth' ||
        educationLevel === 'sslc' ||
        educationLevel === 'diploma' ||
        educationLevel === 'puc'
      ) {
        if (educationLevel == 'sslc') {
          data.educationLevel = 'twelfth'
        }
        twelfth = true
      }
    })

    if (!tenth) {
      educationsList.push({
        component: EducationForm,
        level: 'tenth',
        label: '10th',
        type: true,
      })
    }
    // if (!twelfth) {
    //   educationsList.push({
    //     component: EducationForm,
    //     level: 'twelfth',
    //     label: '12th',
    //     type: true,
    //   })
    // }
    educationList
      ?.filter(item => item?.educationLevel)
      ?.map(data => {
        let educationLevel = data.educationLevel?.toLowerCase()
        let type =
          educationLevel === 'tenth' ||
          (educationLevel === 'twelfth') | (educationLevel === 'hsc') ||
          educationLevel === 'sslc'
        let level = getEducationLevelValue(
          educationLevel != '' ? educationLevel : 'ug',
          true,
          educationsList
        )

        let board = boardList[boardList?.length - 1]?.name
        if (type && data?.board) {
          let actucallBoardName = getBoardbyName(boardList, data?.board)
          if (actucallBoardName) {
            board = actucallBoardName?.name
          } else {
            const normalizedBoardName = normalizeString(data?.board || '')
            let boardName = getBoardbyName(boardList, normalizedBoardName)
            if (boardName) {
              board = boardName?.name
            }
          }
        }
        const getPendingValue = (fieldName, defaultValue) => {
          return data?._pendingFields?.[fieldName]?.value ?? defaultValue
        }

        let initialFields = {
          educationLevel: level,
          university: getPendingValue('university', data?.university),
          universityId: getPendingValue('universityId', data?.universityId),
          institutionId: getPendingValue('institutionId', data?.institutionId),
          institutionName: type ? '' : getPendingValue('institutionName', data?.institutionName),
          collegeName: type ? '' : getPendingValue('collegeName', data?.collegeName),
          collegeId: getPendingValue('collegeId', data?.collegeId),
          board: getPendingValue('board', board),
          degree: getPendingValue('degree', data?.degree),
          department: getPendingValue('department', data?.department),
          specialisation: getPendingValue('specialisation', data?.specialisation),
          degreeStreamMapId: getPendingValue('degreeStreamMapId', data?.degreeStreamMapId),
          degreeId: getPendingValue('degreeId', data?.degreeId),
          streamId: getPendingValue('streamId', data?.streamId),
          specialisationId: getPendingValue('specialisationId', data?.specialisationId),
          startedOn:
            getPendingValue('startedOn', data?.startedOn) > 0
              ? moment(parseInt(getPendingValue('startedOn', data?.startedOn))).format('MM/YYYY')
              : null,
          endedOn:
            getPendingValue('endedOn', data?.endedOn) > 0
              ? moment(parseInt(getPendingValue('endedOn', data?.endedOn))).format('MM/YYYY')
              : null,
          marks: getPendingValue('marks', data?.marks) ? parseFloat(getPendingValue('marks', data?.marks)).toFixed(2) : null,
          endedYear:
            getPendingValue('endedOn', data?.endedOn) > 0
              ? moment(parseInt(getPendingValue('endedOn', data?.endedOn))).format('YYYY')
              : null,
          averageMarks: getPendingValue('averageMarks', data?.averageMarks) ? parseFloat(getPendingValue('averageMarks', data?.averageMarks)).toFixed(2) : null,
          noOfArrears: getPendingValue('noOfArrears', data?.noOfArrears),
          historyOfArrears: getPendingValue('historyOfArrears', data?.historyOfArrears),
          state: getPendingValue('state', data?.state),
          stateId: getPendingValue('stateId', data?.stateId),
          city: getPendingValue('city', data?.city),
          cityId: getPendingValue('cityId', data?.cityId),
          skills: getPendingValue('skills', data?.skills || []),
          awards: getPendingValue('awards', data?.awards),
          domain: getPendingValue('domain', data?.domain),
          domainId: getPendingValue('domainId', data?.domainId),
          isDelete: false,
        }

        let educationListObj = {
          component: EducationForm,
          level: level,
          label: getEducationLevelLabel(data?.educationLevel),
          type: type,
          isCurrentCourse: !!data?.isCurrentCourse,
          hasPendingChanges: !!data?._hasPendingChanges,
          requestId: data?._requestId,
          pendingFields: data?._pendingFields,
        }
        if (data?.degreeStreamMapId) {
          initialFields.degreeStreamMapId = data?.degreeStreamMapId
        }
        if (data?.tcUrl?.url) {
          initialFields.tcUrl = data?.tcUrl
        }
        if (data?.markSheetUrl?.url) {
          initialFields.markSheetUrl = data?.markSheetUrl
        }
        if (data?.id) {
          initialFields.id = data?.id
          educationListObj.id = data?.id
        }
        form.setFieldsValue({
          [level]: initialFields,
        })
        return educationsList.push(educationListObj)
      })
    setUpdatedList(educationsList)
    setEducation(educationsList)

    setTimeout(() => {
      setLoading(false)
    }, 2000)
  }, [educationList])

  useLayoutEffect(() => {
    let currentCourseData = studentData?.currentCourse
    let cvEducationDetails = studentData?.cvDetails?.education || []
    let cvCurrentCourse = studentData?.cvDetails?.currentCourse
    let averageMarks =
      currentCourseData?.averageMarks > 0
        ? currentCourseData?.averageMarks
        : cvCurrentCourse?.averageMarks

    setExamType(currentCourseData?.examType)
    setDuration(currentCourseData?.duration)
    let currentCourse = {
      id: currentCourseData?.id,
      isCurrentCourse: true,
      university: currentCourseData?.university,
      universityId: currentCourseData?.universityId,
      educationLevel: currentCourseData?.educationLevel,
      collegeName: studentFormData?.student?.instituteCampusName,
      instituteCampusName: currentCourseData?.instituteCampusName,
      collegeId: studentData?.student?.instituteCampusId,
      board: '',
      degree: currentCourseData?.degree,
      department: currentCourseData?.department,
      specialisation: currentCourseData?.specialisation,
      degreeStreamMapId: currentCourseData?.degreeStreamMapId,
      degreeId: currentCourseData?.degreeId,
      streamId: currentCourseData?.streamId,
      specialisationId: currentCourseData?.specialisationId,
      startedOn: currentCourseData?.startedOn,
      endedOn: currentCourseData?.endedOn,
      skills: currentCourseData?.skills || [],
      averageMarks: averageMarks || 0,
      state: currentCourseData?.state || '',
      stateId: currentCourseData?.stateId || '',
      city: currentCourseData?.city || '',
      cityId: currentCourseData?.cityId || '',
      noOfArrears: currentCourseData?.noOfArrears,
      historyOfArrears: currentCourseData?.historyOfArrears,
      domain: currentCourseData?.domain,
      domainId: currentCourseData?.domainId,
      marks: currentCourseData?.averageMarks ? parseFloat(currentCourseData?.averageMarks).toFixed(2) : null,
    }
    let educations = studentData?.educationProfile
    if (!educations?.length && cvEducationDetails?.length) {
      const modifiedEducationDetails = cvEducationDetails
        ?.filter(item => item?.educationLevel)
        ?.map((data, index) => {
          if (/^\d{4}$/.test(data?.endedOn.toString())) {
            data.endedOn = `01/01/${data?.endedOn}`
          }
          if (moment(data?.endedOn, 'DD/MM/YYYY').isValid()) {
            data.endedOn = data.endedOn
              ? moment(data?.endedOn, 'DD/MM/YYYY').format('x')
              : null
          }
          if (/^\d{4}$/.test(data?.startedOn.toString())) {
            data.startedOn = `01/${data?.startedOn}`
          }
          if (moment(data?.startedOn, 'MM/YYYY').isValid()) {
            data.startedOn = data.startedOn
              ? moment(data?.startedOn, 'MM/YYYY').format('x')
              : null
          }

          return data
        })
      educations = modifiedEducationDetails
    }
    
    const pendingEducation = pendingData?.education || []
    educations = mergePendingWithApproved(educations || [], pendingEducation)
    
    if (!studentData?.isExpCandidate) {
      let educationList =
        educations?.length > 0
          ? [...educations, currentCourse]
          : [currentCourse]

      // Remove duplicate twelfth entries, keeping the most recent one
      const twelfthEntries = educationList.filter(
        edu => edu?.educationLevel === 'twelfth'
      )
      if (twelfthEntries.length > 1) {
        // Sort twelfth entries by endedOn date
        twelfthEntries.sort((a, b) => {
          const endedA = moment(parseInt(a?.endedOn))
          const endedB = moment(parseInt(b?.endedOn))
          if (!endedA.isValid() || !endedB.isValid()) return 0
          return endedB.valueOf() - endedA.valueOf()
        })
        // Keep only the most recent twelfth entry
        const mostRecentTwelfth = twelfthEntries[0]
        educationList = educationList.filter(
          edu => edu?.educationLevel !== 'twelfth' || edu === mostRecentTwelfth
        )
      }

      educationList?.sort((a, b) => {
        const endedA = moment(parseInt(a?.endedOn))
        const endedB = moment(parseInt(b?.endedOn))

        // Check if both dates are valid
        if (!endedA.isValid() || !endedB.isValid()) {
          return 0
        }

        // Sort by the "ended_in" date in descending order
        if (endedB.isAfter(endedA)) return 1
        if (endedA.isAfter(endedB)) return -1
        return 0
      })

      setEducationList(educationList)
    } else if (studentData?.isExpCandidate) {
      let educationList = educations

      // Remove duplicate twelfth entries for experienced candidates too
      const twelfthEntries = educationList.filter(
        edu => edu?.educationLevel === 'twelfth'
      )
      if (twelfthEntries?.length > 1) {
        twelfthEntries.sort((a, b) => {
          const endedA = moment(parseInt(a?.endedOn))
          const endedB = moment(parseInt(b?.endedOn))
          if (!endedA.isValid() || !endedB.isValid()) return 0
          return endedB.valueOf() - endedA.valueOf()
        })
        const mostRecentTwelfth = twelfthEntries[0]
        educationList = educationList.filter(
          edu => edu?.educationLevel !== 'twelfth' || edu === mostRecentTwelfth
        )
      }

      educationList?.sort((a, b) => {
        const endedA = moment(parseInt(a?.endedOn))
        const endedB = moment(parseInt(b?.endedOn))

        // Check if both dates are valid
        if (!endedA.isValid() || !endedB.isValid()) {
          return 0
        }

        // Sort by the "ended_in" date in descending order
        if (endedB.isAfter(endedA)) return 1
        if (endedA.isAfter(endedB)) return -1
        return 0
      })
      setEducationList(educationList)
    }
  }, [studentData])
  // Education handlers
  const subjectHandler = (educationLevel, option) => {
    setStateId('')
    setCityId('')
    setRefreshKey(refreshKey + 1)
    let arr = []
    let type =
      option?.value === 'tenth' ||
      option?.value === 'twelfth' ||
      option?.value === 'hsc' ||
      option?.value === 'sslc' ||
      option?.value === 'ug'
    arr.push({
      component: EducationForm,
      level: option?.value,
      label: option?.label,
      type: type,
    })
    let levelsList = updatedList?.map(data => data?.level)
    if (educationLevel !== true && !levelsList.includes(educationLevel)) {
      setEducation(edu => edu.concat(arr))
      setUpdatedList(edu => edu.concat(arr))
    }
  }

  const onRemoveEducation = async (deleteLevel, educationId) => {
    let updatedListData = updatedList?.filter(
      data => data?.level !== deleteLevel
    )
    if (educationId) {
      SuccessMessage('Deleted successfully!')
      form.setFieldsValue({
        [deleteLevel]: '',
      })
      const newDeleteLevel = deleteLevel + 'deleted'
      form.setFieldsValue({
        [newDeleteLevel]: { id: educationId, isDelete: true },
      })
      setUpdatedList(updatedListData)
    } else {
      form.setFieldsValue({
        [deleteLevel]: undefined,
      })
      setUpdatedList(updatedListData)
    }
  }

  // Address handlers for the Current Address section
  const onCorrCountryChange = (data, option) => {
    form.setFieldsValue({
      corrCountry: data,
      corrState: '',
      corrCity: '',
      corrCountryId: option?.option?._id,
      corrStateId: '',
      corrCityId: '',
    });
    // formRef.current.setFields([
    //   {
    //     name: 'corrCountry',
    //     errors: [],
    //   },
    // ]);
    setCorrCountryName(data);
    setCorrCountryId(option?.option?._id);
    setCorrStateId('');
    setCorrStateName('');
    setCorrCityName('');
    setCorrCityId('');

    getStateData(option?.option?._id, false);
  };

  const onCorrStateChange = (data, option) => {
    form.setFieldsValue({
      corrState: data,
      corrCity: '',
      corrStateId: option?.option?._id,
      corrCityId: '',
    });
    // formRef.current.setFields([
    //   {
    //     name: 'corrState',
    //     errors: [],
    //   },
    // ]);
    setCorrStateId(option?.option?._id);
    setCorrStateName(data);
    setCorrCityName('');
    setCorrCityId('');
    if (!isSameAddress) {
      getStateData(corrCountryId, false);
      getCityData(corrCountryId, option?.option?._id, false);
    }
  };

  const onCorrCityChange = (data, option) => {
    form.setFieldsValue({ corrCity: data, corrCityId: option?.option?._id });
    // formRef.current.setFields([
    //   {
    //     name: 'corrCity',
    //     errors: [],
    //   },
    // ]);
    setCorrCityName(data);
    setCorrCityId(option?.option?._id);
    !isSameAddress && getCityData(corrCountryId, corrStateId, false);
  };

  useEffect(() => {
    if(isSameAddress){
      form.setFieldsValue({
        corrAddrLine1: form.getFieldValue('permAddrLine1'),
        corrAddrLine2: form.getFieldValue('permAddrLine2'),
        corrCountry: permCountryName,
        corrState: permStateName,
        corrCity: permCityName,
        corrCountryId: permCountryId,
        corrStateId: permStateId,
        corrCityId: permCityId,
        corrPostCode: form.getFieldValue('permPostCode'),
      });
      setCorrCountryName(permCountryName);
      setCorrStateName(permStateName);
      setCorrCityName(permCityName);
      setCorrCountryId(permCountryId);
      setCorrStateId(permStateId);
      setCorrCityId(permCityId);
      
    }
  },[permCityId,permStateId,permCountryId,form.getFieldValue('permPostCode')])

  const sameAddressOnChange = data => {
    setIsSameAddress(data?.target?.checked);
    if (data?.target?.checked) {
      setCorrCountryName(permCountryName);
      setCorrStateName(permStateName);
      setCorrCityName(permCityName);
      setCorrCountryId(permCountryId);
      setCorrStateId(permStateId);
      setCorrCityId(permCityId);
      form.setFieldsValue({
        corrAddrLine1: form.getFieldValue('permAddrLine1'),
        corrAddrLine2: form.getFieldValue('permAddrLine2'),
        corrCountry: permCountryName,
        corrState: permStateName,
        corrCity: permCityName,
        corrCountryId: permCountryId,
        corrStateId: permStateId,
        corrCityId: permCityId,
        corrPostCode: form.getFieldValue('permPostCode'),
      });
    } else {
      setCorrCountryName('');
      setCorrStateName('');
      setCorrCityName('');
      setCorrCountryId('');
      setCorrStateId('');
      setCorrCityId('');
      setCorrStateList([]);
      setCorrCityList([]);
      getCountryData('');
      form.setFieldsValue({
        corrAddrLine1: '',
        corrAddrLine2: '',
        corrCountry: '',
        corrState: '',
        corrCity: '',
        corrCountryId: '',
        corrStateId: '',
        corrCityId: '',
        corrPostCode: '',
      });
    }
  };

  // Using existing functions from earlier in the file

  // Adding the missing functions for Current Address state and city search
  const delayCorrCountryToDb = useCallback(
    debounce(data => {
      // Only affect Current Address fields, not Permanent Address
      if (!isSameAddress) {
        getCountryData(data, true); // true means it's for Current Address
        setErrorNote(prevError => ({
          ...prevError,
          'corrCountry': '',
          'corrState': '',
          'corrCity': '',
        }));
      }
    }, 500),
    [isSameAddress]
  );

  const delayCorrStateToDb = useCallback(
    debounce((countryId, data) => {
      if (!isSameAddress && countryId) {
        // Create a separate state list for current address
        setLoadingState(true);
        const fetchStateData = async () => {
          let list = await getListOfState(countryId, data, true, setLoadingState);
          setCorrStateList(list || []);
        };
        fetchStateData();
        setErrorNote(prevError => ({
          ...prevError,
          'corrState': '',
          'corrCity': '',
        }));
      }
    }, 500),
    [isSameAddress]
  );

  const delayCorrCityToDb = useCallback(
    debounce((countryId, stateId, data) => {
      if (!isSameAddress && countryId && stateId) {
        // Create a separate city list for current address
        setLoadingCity(true);
        const fetchCityData = async () => {
          let list = await getListOfCity(countryId, stateId, data, true, setLoadingCity);
          setCorrCityList(list || []);
        };
        fetchCityData();
        setErrorNote(prevError => ({
          ...prevError,
          'corrCity': '',
        }));
      }
    }, 500),
    [isSameAddress]
  );

  // Skills API handler
  const SkillsAPI = async search => {
    try {
      const results = await searchAPI(
        searchConfig?.skills?.name,
        search,
        searchConfig?.skills
      )
      let updatedSkills = results || []
      const newSkill = {
        name: search,
        id: Math.random().toString(36).substr(2, 8),
      }
      if (updatedSkills?.length === 0 && search) {
        setListOfAddedSkills(prev => [...prev, newSkill])
        updatedSkills = [newSkill, ...updatedSkills]
      }

      const isExactMatch = updatedSkills.some(
        skill => skill?.name.toLowerCase() === search?.toLowerCase()
      )
      if (updatedSkills?.length > 0) {
        if (!isExactMatch && search?.length > 3) {
          setListOfAddedSkills(prev => [...prev, newSkill])
          updatedSkills = [newSkill, ...updatedSkills]
        }
      }

      if (!allSkills?.length) {
        setAllSkills(updatedSkills)
      }
      setSkillLoading(false)
      return updatedSkills
    } catch (error) {
      setSkillLoading(false)
      console.error(`Error searching ${searchConfig?.skills?.name}:`, error)
    }
  }

  // Initialize university search
  useEffect(() => {
    searchAPI(searchConfig?.universities?.name, '', searchConfig?.universities)
      .then(results => setUniversitySearchList(results))
      .catch(error =>
        console.error(
          `Error searching ${searchConfig?.universities?.name}:`,
          error
        )
      )
    SkillsAPI()
  }, [])

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      centered
      width="80%"
      footer={null}
      maskClosable={false}
      closable={false}
      destroyOnClose={true}
      bodyStyle={{
        padding: '0',
        borderRadius: '10px',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Form
        scrollToFirstError
        onFinish={handleSubmit}
        id={'personalForm'}
        form={form}
        ref={formRef}
        onFinishFailed={({ errorFields }) => {
          scrollToFirstError(errorFields)
        }}
        layout="vertical"
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          overflow: 'hidden',
        }}
      >
        {/* Fixed Header */}
        <div
          style={{
            padding: '5px 20px',
            borderBottom: '1px solid #E6E7EA',
            position: 'sticky',
            top: 0,
            background: 'white',
            zIndex: 10,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <TitleTextPopup></TitleTextPopup>
          <StyledDiv onClick={onClose} style={{ cursor: 'pointer' }}>
            <CrossIconSkill />
          </StyledDiv>
        </div>

        {/* Scrollable Content */}
        <div
          style={{
            padding: '15px 20px',
            overflowY: 'auto',
            flex: 1,
          }}
        >
          <Control column gap="14px">
            {/* CV Upload Section */}
            <div style={{ width: '100%' }}>
              <TitleTextPopup>Personal Information</TitleTextPopup>
              <Label>Upload CV</Label>
              {/* {
                !file && (
                  <Uploadloader
                    width="100%"
                    height="190px"
                    setFile={setFile}
                    isDefault={true}
                    fileName={
                      studentData?.studentPersonalProfile?.firstName
                        ?.toLowerCase()
                        ?.replace(/\s/g, '') + '_CV'
                    }
                    isCV={true}
                    onlyDoc={true}
                  />
                )}
              {file && (
                <FileReader
                  file={file}
                  setFile={setFile}
                />
              )} */}

              {loadingCV ? (
                !progress || progress == 100 ? (
                  <Spin />
                ) : (
                  <Control center>
                    <Progress percent={progress} type="circle" />
                  </Control>
                )
              ) : (
                <>
                  {prevCvUrl ? (
                    <Control column top="10px" center>
                      <FileReader
                        file={{
                          ...prevCvUrl,
                          name:
                            studentData?.admin?.first_name
                              ?.toLowerCase()
                              ?.replace(/\s/g, '') +
                            ' ' +
                            studentData?.admin?.last_name
                              ?.toLowerCase()
                              ?.replace(/\s/g, '') +
                            '_CV',
                        }}
                        setFile={removeCv}
                        isView
                        fileName={
                          studentData?.admin?.first_name
                            ?.toLowerCase()
                            ?.replace(/\s/g, '') +
                          studentData?.admin?.last_name
                            ?.toLowerCase()
                            ?.replace(/\s/g, '') +
                          '_CV'
                        }
                      />
                    </Control>
                  ) : (
                    <Control column top="10px" center>
                      <Uploadloader
                        width="100%"
                        height="190px"
                        isDefault={true}
                        fileName={
                          studentData?.admin?.first_name
                            ?.toLowerCase()
                            ?.replace(/\s/g, '') +
                          studentData?.admin?.last_name
                            ?.toLowerCase()
                            ?.replace(/\s/g, '') +
                          '_CV'
                        }
                        isCV={true}
                        onlyDoc={true}
                        setFile={uploadCV}
                      />
                    </Control>
                  )}
                </>
              )}
            </div>

            {/* {((studentData?.studentPersonalProfile?.dob === null || studentData?.studentPersonalProfile?.dob === undefined || studentData?.studentPersonalProfile?.dob === '' ) && (studentData?.studentPersonalProfile?.gender === null || studentData?.studentPersonalProfile?.gender === undefined || studentData?.studentPersonalProfile?.gender === '' )) && ( */}
            <Control row gap="20px">
              {(studentData?.studentPersonalProfile?.dob === null ||
                studentData?.studentPersonalProfile?.dob === undefined ||
                studentData?.studentPersonalProfile?.dob === '') && (
                <Control column width="49%">
                  <FormItem
                    name="dob"
                    rules={[
                      {
                        required: true,
                        message: 'Please select your date of birth',
                      },
                    ]}
                  >
                    <Label>Date of Birth *</Label>
                    <Date
                      placeholder="DD/MM/YYYY"
                      onChange={onDateChange}
                      value={dob ? moment(dob) : null}
                      format="DD/MM/YYYY"
                      disabledDate={d => !d || d.isAfter(moment())}
                      inputReadOnly
                    />
                  </FormItem>
                </Control>
              )}
              {(studentData?.studentPersonalProfile?.gender === null ||
                studentData?.studentPersonalProfile?.gender === undefined ||
                studentData?.studentPersonalProfile?.gender === '') && (
                <Control column width="49%">
                  <FormItem
                    name="gender"
                    rules={[
                      { required: true, message: 'Please select your gender' },
                    ]}
                  >
                    <Label>Gender *</Label>
                    <AntdSelect
                      placeholder="Select gender"
                      options={genderOptions}
                      value={gender}
                      onChange={onGenderChange}
                    />
                  </FormItem>
                </Control>
              )}
            </Control>
            {/* )} */}
            {(studentData?.admin?.phone_number === null ||
              studentData?.admin?.phone_number === undefined ||
              studentData?.admin?.phone_number === '') && (
              <>
                <TitleTextPopup marginBottom="2px">
                  Contact Details
                </TitleTextPopup>
                <Control row gap="10px">
                  <Control column width="49%">
                    <Control flexStart column>
                      <Label>Phone No *</Label>
                      <Control>
                        <StyledSelectDiv>
                          <AntdSelect
                            width="100%"
                            OptionData={CountryCode}
                            nameParam="value"
                            bordered={false}
                            placeholder="+91"
                            onChange={onCountryCodeChange}
                            value={countryCode}
                            disabled={true}
                          />
                        </StyledSelectDiv>
                        <StyledInputDiv>
                          <StyledInput
                            width="100%"
                            placeholder="Eg: 1010101010"
                            rules={[
                              {
                                required: true,
                                min: 10,
                                max: 10,
                                message: 'Please Enter a valid phone number!',
                              },
                              {
                                validator: validatePhoneNumber,
                              },
                            ]}
                            name={'phoneNumber'}
                          />
                        </StyledInputDiv>
                      </Control>
                    </Control>
                  </Control>
                </Control>
              </>
            )}

            {/* Permanent Address */}
            <TitleTextPopup marginBottom="2px">
              Permanent Address
            </TitleTextPopup>

            {/* <Control row gap="20px">
              <Control column width="49%">
                <FormItem
                  name="permAddrLine1"
                  rules={[{ required: true, message: 'Please enter address line 1' }]}
                >
                  <Label>Address Line 1 *</Label>
                  <StyledInput
                    placeholder="Address Line 1"
                  />
                </FormItem>
              </Control>

              <Control column width="49%">
                <FormItem
                  name="permAddrLine2"
                >
                  <Label>Address Line 2</Label>
                  <StyledInput
                    placeholder="Address Line 2"
                  />
                </FormItem>
              </Control>
            </Control> */}

            <Control row gap="20px">
              <Control column width="49%">
                <FormItem
                  name="permCountry"

                  //    rules={[{ required: true, message: 'Please select a country' }]}
                >
                  <Label>Country *</Label>
                </FormItem>
                <AntdSelect
                  placeholder="Select"
                  name={'permCountryId'}
                  filterOption={false}
                  rules={[
                    // {
                    //   required: true,
                    //   message: 'Please select country!',
                    // },
                    {
                      validator: async (_, value) => {
                        if (value) {
                          let masterList = await isCorporateMasterExist(
                            value,
                            'permCountry'
                          )

                          if (masterList) {
                            return Promise.reject(
                              new Error('Please select country!')
                            )
                          } else {
                            return Promise.resolve()
                          }
                        }
                        return Promise.resolve()
                      },
                    },
                  ]}
                  OptionData={loadingCountry ? [] : permCountryList}
                  notFoundContent={
                    loadingCountry ? (
                      <SpinWrapper center>
                        <Spin />
                      </SpinWrapper>
                    ) : (
                      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    )
                  }
                  valueParam="name"
                  nameParam="name"
                  onChange={onCountryChange}
                  value={permCountryName}
                  showSearch={true}
                  onSearch={data => {
                    setLoadingCountry(true)
                    delayCountryToDb(data)
                  }}
                />
                {errorNote.permCountry && (
                  <RedNote>{errorNote.permCountry}</RedNote>
                )}
              </Control>

              <Control column width="49%">
                <FormItem
                  name="permState"
              //    rules={[{ required: true, message: 'Please select a state' }]}
                >
                  <Label>State *</Label>
                </FormItem>
                <AntdSelect
                  showSearch={true}
                  filterOption={false}
                  placeholder="Select"
                  name={'permStateId'}
                  rules={[
                    {
                      required: true,
                      message: 'Please select state!',
                    },
                    {
                      validator: async (_, value) => {
                        if (value) {
                          try {
                            let masterList = await isCorporateMasterExist(
                              value,
                              'permState'
                            )

                            if (masterList) {
                              return Promise.reject(
                                new Error('Please select state!')
                              )
                            } else {
                              return Promise.resolve()
                            }
                          } catch (error) {
                            console.error('Error validating state:', error)
                            return Promise.resolve()
                          }
                        }
                        return Promise.resolve()
                      },
                    },
                  ]}
                  OptionData={loadingState ? [] : permStateList}
                  notFoundContent={
                    loadingState ? (
                      <SpinWrapper center>
                        <Spin />
                      </SpinWrapper>
                    ) : (
                      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    )
                  }
                  valueParam="name"
                  nameParam="name"
                  onChange={onStateChange}
                  value={permStateName}
                  disabled={!permCountryId ? true : false}
                  onSearch={data => {
                    setLoadingState(true)
                    delayStateToDb(permCountryId, data)
                  }}
                />
                {errorNote.permState && (
                  <RedNote>{errorNote.permState}</RedNote>
                )}
              </Control>
            </Control>

            <Control row gap="20px">
              <Control column width="49%">
                <FormItem
                  name="permCity"

                  //   rules={[{ required: true, message: 'Please select a city' }]}
                >
                  <Label>City *</Label>
                </FormItem>

                <AntdSelect
                  placeholder="Select"
                  name={'permCityId'}
                  filterOption={false}
                  rules={[
                    {
                      required: true,
                      message: 'Please select city!',
                    },

                    {
                      validator: async (_, value) => {
                        if (value) {
                          let masterList = await isCorporateMasterExist(
                            value,
                            'permCity'
                          )

                          if (masterList) {
                            return Promise.reject(
                              new Error('Please select city!')
                            )
                          } else {
                            return Promise.resolve()
                          }
                        }
                        return Promise.resolve()
                      },
                    },
                  ]}
                  OptionData={loadingCity ? [] : permCityList}
                  notFoundContent={
                    loadingCity ? (
                      <SpinWrapper center>
                        <Spin />
                      </SpinWrapper>
                    ) : (
                      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    )
                  }
                  valueParam="name"
                  nameParam="name"
                  onChange={onCityChange}
                  value={permCityName}
                  showSearch={true}
                  disabled={!permStateId ? true : false}
                  onSearch={data => {
                    setLoadingCity(true)
                    delayCitiesToDb(permCountryId, permStateId, data)
                  }}
                />
                {errorNote.permCity && <RedNote>{errorNote.permCity}</RedNote>}
              </Control>

              <Control column width="49%">
                <FormItem
                  name="permPostCode"

                  // rules={[
                  //   { required: true, message: 'Please enter PIN code' },
                  //   { pattern: /^[0-9]{6}$/, message: 'Please enter a valid 6-digit PIN code' }
                  // ]}
                >
                  <Label>Pincode *</Label>

                  <AntdInput
                    placeholder="121212"
                    name={'permPostCode'}
                    type={'number'}
                    rules={[
                      {
                        validator: (_, value) => {
                          if (value >= 100000 && value <= 999999) {
                            return Promise.resolve()
                          } else {
                            return Promise.reject(
                              new Error('Please Enter a valid 6-digit PIN code')
                            )
                          }
                        },
                      },
                    ]}
                    value={form.getFieldValue('permPostCode')}
                  />
                </FormItem>
              </Control>
            
            </Control>

            {/* Current Address */}
            <Control top="35px" spaceBetween>
              <TitleTextPopup marginBottom="2px">Current Address</TitleTextPopup>
              <CheckboxData
                label={'Same as permanent address'}
                onChange={sameAddressOnChange}
                value={isSameAddress}
              />
            </Control>
            
            {/* <Control row gap="20px">
              <Control column width="49%">
                <FormItem
                  name="corrAddrLine1"
                  rules={[{ required: true, message: 'Please enter address line 1' }]}
                >
                  <Label>Address Line 1 *</Label>
                  <StyledInput
                    placeholder="Address Line 1"
                    disabled={isSameAddress}
                  />
                </FormItem>
              </Control>

              <Control column width="49%">
                <FormItem
                  name="corrAddrLine2"
                >
                  <Label>Address Line 2</Label>
                  <StyledInput
                    placeholder="Address Line 2"
                    disabled={isSameAddress}
                  />
                </FormItem>
              </Control>
            </Control> */}

            <Control row gap="20px">
              <Control column width="49%">
                <FormItem
                  name="corrCountry"
                  rules={[{ required: true, message: 'Please select a country' }]}
                >
                  <Label>Country *</Label>
                </FormItem>
                <AntdSelect
                  placeholder="Select"
                  name={'corrCountryId'}
                  filterOption={false}
                  rules={[
                    {
                      required: true,
                      message: 'Please select country!',
                    },
                    {
                      validator: async (_, value) => {
                        if (value) {
                          let masterList = await isCorporateMasterExist(
                            value,
                            'corrCountry'
                          )
                          if (masterList) {
                            return Promise.reject(new Error('Please select country!'))
                          } else {
                            return Promise.resolve()
                          }
                        }
                        return Promise.resolve()
                      },
                    },
                  ]}
                  OptionData={loadingCountry ? [] : corrCountryList}
                  notFoundContent={
                    loadingCountry ? (
                      <SpinWrapper center>
                        <Spin />
                      </SpinWrapper>
                    ) : (
                      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    )
                  }
                  valueParam="name"
                  nameParam="name"
                  onChange={onCorrCountryChange}
                  value={corrCountryName}
                  showSearch={true}
                  onSearch={data => {
                    setLoadingCountry(true);
                    delayCorrCountryToDb(data);
                  }}
                  disabled={isSameAddress}
                />
                {errorNote.corrCountry && <RedNote>{errorNote.corrCountry}</RedNote>}
              </Control>

              <Control column width="49%">
                <FormItem
                  name="corrState"
                 // rules={[{ required: true, message: 'Please select a state' }]}
                >
                  <Label>State *</Label>
                </FormItem>
                <AntdSelect
                  showSearch={true}
                  filterOption={false}
                  placeholder="Select"
                  name={'corrStateId'}
                  rules={[
                    {
                      required: true,
                      message: 'Please select state!',
                    },
                    {
                      validator: async (_, value) => {
                        if (value) {
                          try {
                            let masterList = await isCorporateMasterExist(
                              value,
                              'corrState'
                            )
                            if (masterList) {
                              return Promise.reject(new Error('Please select state!'))
                            } else {
                              return Promise.resolve()
                            }
                          } catch (error) {
                            console.error('Error validating state:', error)
                            return Promise.resolve()
                          }
                        }
                        return Promise.resolve()
                      },
                    },
                  ]}
                  OptionData={loadingState ? [] : corrStateList}
                  notFoundContent={
                    loadingState ? (
                      <SpinWrapper center>
                        <Spin />
                      </SpinWrapper>
                    ) : (
                      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    )
                  }
                  valueParam="name"
                  nameParam="name"
                  onChange={onCorrStateChange}
                  value={corrStateName}
                  disabled={isSameAddress || !corrCountryId}
                  onSearch={data => {
                    setLoadingState(true);
                    delayCorrStateToDb(corrCountryId, data);
                  }}
                />
                {errorNote.corrState && <RedNote>{errorNote.corrState}</RedNote>}
              </Control>
            </Control>

            <Control row gap="20px">
              <Control column width="49%">
                <FormItem
                  name="corrCity"
                 // rules={[{ required: true, message: 'Please select a city' }]}
                >
                  <Label>City *</Label>
                </FormItem>
                <AntdSelect
                  placeholder="Select"
                  name={'corrCityId'}
                  filterOption={false}
                  rules={[
                    {
                      required: true,
                      message: 'Please select city!',
                    },
                    {
                      validator: async (_, value) => {
                        if (value) {
                          let masterList = await isCorporateMasterExist(
                            value,
                            'corrCity'
                          )
                          if (masterList) {
                            return Promise.reject(new Error('Please select city!'))
                          } else {
                            return Promise.resolve()
                          }
                        }
                        return Promise.resolve()
                      },
                    },
                  ]}
                  OptionData={loadingCity ? [] : corrCityList}
                  notFoundContent={
                    loadingCity ? (
                      <SpinWrapper center>
                        <Spin />
                      </SpinWrapper>
                    ) : (
                      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    )
                  }
                  valueParam="name"
                  nameParam="name"
                  onChange={onCorrCityChange}
                  value={corrCityName}
                  showSearch={true}
                  disabled={isSameAddress || !corrStateId}
                  onSearch={data => {
                    setLoadingCity(true);
                    delayCorrCityToDb(corrCountryId, corrStateId, data);
                  }}
                />
                {errorNote.corrCity && <RedNote>{errorNote.corrCity}</RedNote>}
              </Control>

              <Control column width="49%">
                <FormItem
                  name="corrPostCode"
                >
                  <Label>Pincode *</Label>
                  <AntdInput
                    placeholder="121212"
                    name={'corrPostCode'}
                    type={'number'}
                    rules={[
                      {
                        validator: (_, value) => {
                          if (value >= 100000 && value <= 999999) {
                            return Promise.resolve()
                          } else {
                            return Promise.reject(new Error('Please Enter a valid 6-digit PIN code'))
                          }
                        },
                      },
                    ]}
                    value={form.getFieldValue('corrPostCode')}
                    disabled={isSameAddress}
                  />
                </FormItem>
              </Control>
            </Control>

            {/* Preferred Job Location */}
            <Control column top="10px" width="49%">
              <Label>Preferred Location *</Label>
              <Control column bottom="10px">
                <Checkbox onChange={isAnyWhereOnChange} checked={isAnyWhere}>
                  {'Anywhere'}
                </Checkbox>
              </Control>

              {!isAnyWhere && (
                <>
                  <FormItem
                    style={{ height: '10px' }}
                    name={'preferredJobLocation'}
                  >
                    <div></div>
                  </FormItem>

                  <AntdSelect
                    placeholder="Eg.Chennai"
                    name={'preferredJobLocation'}
                    rules={[
                      {
                        validator: async (_, value) => {
                          if (
                            !locations?.length &&
                            (!Array.isArray(value) || value?.length === 0)
                          ) {
                            return Promise.reject(
                              new Error('Please enter preferred job location!')
                            )
                          }
                          return Promise.resolve()
                        },
                      },
                    ]}
                    OptionData={perfCityList}
                    filterOption={false}
                    onChange={locationHandler}
                    value={locations}
                    mode="multiple"
                    maxTagCount={3}
                    valueParam="value"
                    nameParam="label"
                    showSearch={true}
                    iskey={true}
                    onSearch={data =>
                      delayCitiesToDbForPreferredLocationSearch(data)
                    }
                    // onDropdownVisibleChange={open => {
                    //   if (!open) {
                    //     delayCitiesToDbForPreferredLocationSearch('')
                    //     form.setFieldsValue({
                    //       preferredJobLocation: locations,
                    //     })
                    //   }
                    // }}
                  />
                </>
              )}
            </Control>

            {/* Education Section */}
            <Heading>Education</Heading>
            <div>
              {!loading && !skillLoading ? (
                <>
                  {education?.length > 0 &&
                    education?.map((type, index) => (
                      <type.component
                        form={form}
                        key={index + 'type'}
                        level={type?.level}
                        label={type?.label}
                        isType={type?.type}
                        onRemoveEducation={onRemoveEducation}
                        universitySearchList={universitySearchList}
                        setUniversitySearchList={setUniversitySearchList}
                        getEducationLevelSearch={getEducationLevelSearch}
                        isCurrentCourse={type?.isCurrentCourse}
                        studentFormData={studentData}
                        getEducationLevel={getEducationLevel}
                        educationId={type?.id}
                        stateId={stateId}
                        setStateId={setStateId}
                        setCityId={setCityId}
                        cityId={cityId}
                        setLocationData={setLocationData}
                        locationData={locationData}
                        universityValue={universityName}
                        setUniversityName={setUniversityName}
                        universityList={universityList}
                        stateList={stateList}
                        getListOfCountries={getListOfCountries}
                        getListOfState={getListOfState}
                        getListOfCity={getListOfCity}
                        examType={examType}
                        duration={duration}
                        setExamType={setExamType}
                        setDuration={setDuration}
                        setSearchState={setSearchState}
                        AllCollegeList={AllCollegeList}
                        setInstituteCampusName={setInstituteCampusName}
                        instituteCampusValue={instituteCampusName}
                        universityId={universityId}
                        setUniversityId={setUniversityId}
                        insttituteId={instituteId}
                        setInstituteId={setInstituteId}
                        getListOfSkills={getListOfSkills}
                        setCurrentInstituteName={setCurrentInstituteName}
                        setCurrentInstituteId={setCurrentInstituteId}
                        CollegeList={CollegeList}
                        setSearchCollege={setSearchCollege}
                        searchCollege={searchCollege}
                        loadingCity={loadingCity}
                        loadingState={loadingState}
                        setLoadingCity={setLoadingCity}
                        setLoadingState={setLoadingState}
                        skillLoading={skillLoading}
                        setSkillLoading={setSkillLoading}
                        searchAPI={searchAPI}
                        SkillsAPI={SkillsAPI}
                        allSkills={allSkills}
                        education={education}
                        shown={shown}
                        hasPendingChanges={type?.hasPendingChanges}
                        requestId={type?.requestId}
                        pendingFields={type?.pendingFields}
                      />
                    ))}
                </>
              ) : (
                <Spin />
              )}
            </div>

            <LocalDiv>
              <Control alignCenter gap="10px">
                <AdjustIcon>
                  <AddIcon />
                </AdjustIcon>
                <Text>
                  
                {updatedList?.some(item => 
                  (item?.level === 'twelfth' || item?.level === 'diploma' || item?.level === 'diploma_0')
                ) 
                  ? "Add Education" 
                  : "12th or Diploma *"}
                </Text>
              </Control>
            </LocalDiv>

            <SelectLocalWrapper
              key={refreshKey}
              onChange={(e, option) => subjectHandler(e, option)}
            >
             {updatedList?.some(item => 
                          (item?.level === 'twelfth' || item?.level === 'diploma' || item?.level === 'diploma_0')
                        ) 
                          ? educationDetails?.map((data, index) => {
                              let valueData = getEducationLevelValue(data?.value, false, [])
                              return (
                                <Option
                                  value={valueData}
                                  key={index + 'data'}
                                  label={getEducationLevelLabel(data?.value)}
                                >
                                  <OptionWrapper alignCenter isAdded={getAddedLevel(valueData)}>
                                    {data?.label}
                                  </OptionWrapper>
                                </Option>
                              )
                            })
                          : educationDetailsBefore?.map((data, index) => {
                              let valueData = getEducationLevelValue(data?.value, false, [])
                              return (
                                <Option
                                  value={valueData}
                                  key={index + 'data'}
                                  label={getEducationLevelLabel(data?.value)}
                                >
                                  <OptionWrapper alignCenter isAdded={getAddedLevel(valueData)}>
                                    {data?.label}
                                  </OptionWrapper>
                                </Option>
                              )
                            })
                        }
            </SelectLocalWrapper>
          </Control>
        </div>

        {/* Fixed Footer */}
        <div
          style={{
            padding: '15px 20px',
            borderTop: '1px solid #E6E7EA',
            position: 'sticky',
            bottom: 0,
            background: 'white',
            zIndex: 10,
          }}
        >
          <FlexWrapRole gap="20px" right>
            <Button.Secondary text="Back" onClick={onClose} />
            <Button.Primary
              text="Submit"
              htmlType={'submit'}
              loading={submitLoading}
              disabled={submitLoading}
            />
          </FlexWrapRole>
        </div>
      </Form>
    </Modal>
  )
}

export default ProfileFormModal
